export function htmlDecode(text: string) {
    var ta = document.createElement('textarea');
    ta.innerHTML = text;
    return ta.value;
}
